import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { FaWindowClose } from "react-icons/fa";
import styles from "./guide/guide.module.scss";
import { convertToCloudFrontUrl } from "../../helper";


const SliderShow = ({ isSwiperModalOpen, postData, handleCloseModal }) => {
  const [images, setImages] = useState([]);

  // Set every time, empty included — a guide with no images used to show the
  // previous guide's slides.
  useEffect(() => {
    const slides = Array.isArray(postData?.carouselImages) ? postData.carouselImages : [];
    setImages(slides.map((item) =>
      item?.image?.uploadedImageUrl ? convertToCloudFrontUrl(item.image.uploadedImageUrl) : null
    ).filter(Boolean));
  }, [postData]);

  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
    },
  };

  return (
    <Modal
      isOpen={isSwiperModalOpen}
      onRequestClose={handleCloseModal}
      style={modalStyle}
      appElement={document.getElementById("root")}
    >
      <div className={styles.boxWrapper}>
        <div className="d-flex justify-content-between fw-bold mb-3">
            <h4>Images</h4>
            <span className={styles.closeBtn} onClick={handleCloseModal}><FaWindowClose size={20}/></span>
          </div>
        <div className={`${styles.content} bg-black`}>
        {images.length > 0 ? (
            <Swiper
              effect="coverflow"
              navigation={true}
              pagination={{ clickable: true }}
              modules={[Navigation, Pagination, EffectCoverflow]}
              slidesPerView={1}
              centeredSlides
              loop={true}
              coverflowEffect={{
                rotate: 10,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
            >
              {images.map((imgUrl, index) => (
                <SwiperSlide key={index}>
                  <img
                    // Already converted when `images` was built — the helper is
                    // idempotent, but calling it twice is the redundancy
                    // CLAUDE.md warns about, so this uses the normalised value.
                    src={imgUrl}
                    alt={`Slide ${index}`}
                    style={{
                      width: "100%",
                      // `contain`, not `cover`: these are whole pages of a
                      // guide, and cover cropped the top and bottom off every
                      // portrait image — the one thing a viewer must not do.
                      // The slide keeps a fixed height so the carousel doesn't
                      // jump between images of different shapes; the black
                      // backdrop makes the letterboxing read as deliberate.
                      height: "70vh",
                      objectFit: "contain",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <p className="text-center">No images available</p>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default SliderShow;
